module.exports = __webpack_public_path__ + "img/wedding_inner_4.78156ef9.jpg";